import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Number from "./Number";
import "./index.sass";
import { useEffect, useState } from "react";

interface PanelNumbersEffectsProps {
  startAnimation: boolean;
  pageId: number;
}

const PanelNumbersEffects = ({ pageId, startAnimation }: PanelNumbersEffectsProps) => {
  const [resetAnimation, setResetAnimation] = useState(false);
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  useEffect(() => {
    if (pageId !== currentPage) setResetAnimation(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const numbersData = [
    {
      initNumber: 0,
      finalNumber: 116.4,
      duration: 840,
      decimal: 1,
      style: { top: "var(--height-285)", left: "var(--width-896)" },
    },
    {
      initNumber: 0,
      finalNumber: 49,
      duration: 1000,
      style: { top: "var(--height-285)", right: "var(--width-640)" },
    },
    {
      initNumber: 0,
      finalNumber: 30,
      duration: 600,
      style: { top: "var(--height-285)", right: "var(--width-270)" },
    },
    {
      initNumber: 30,
      finalNumber: 60,
      duration: 600,
      style: { top: "var(--height-285)", right: "var(--width-190)" },
    },
    {
      initNumber: 0,
      finalNumber: 20,
      duration: 600,
      style: { top: "var(--height-586)", right: "var(--width-1005)" },
    },
    {
      initNumber: 8,
      finalNumber: -26,
      duration: 600,
      style: { top: "var(--height-586)", right: "var(--width-620)" },
    },
    {
      initNumber: 2,
      finalNumber: 15,
      duration: 600,
      style: { top: "var(--height-586)", right: "var(--width-270)" },
    },
  ];

  return (
    <div id="panel-numbers-effect">
      {numbersData.map((numberData, index) => (
        <Number
          key={index}
          startAnimation={startAnimation}
          resetAnimation={resetAnimation}
          {...numberData}
          style={{ opacity: startAnimation ? 1 : 0, ...numberData.style }}
        />
      ))}
    </div>
  );
};

export default PanelNumbersEffects;
